import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoTooltip',
  props: { text: String },
  setup(__props) {

const props = __props;
const textRef = ref(null);
const isOverflow = ref(false);

const handleMouseEnter = () => {
  const el = textRef.value;
  if (el) {
    // 只有文字溢出了，Tooltip 才生效
    isOverflow.value = el.scrollWidth > el.offsetWidth;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    title: __props.text,
    disabled: !isOverflow.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "textRef",
        ref: textRef,
        class: "auto-ellipsis",
        onMouseenter: handleMouseEnter
      }, _toDisplayString(__props.text), 545)
    ]),
    _: 1
  }, 8, ["title", "disabled"]))
}
}

})